import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { LegalBlocks } from './LegalBlocks';

const Section = styled.section`
  margin-bottom: 2rem;
`;
const SectionTitle = styled.h2`
  color: var(--brand-red);
  font-size: 1.25rem;
  margin-bottom: 0.75rem;
  border-bottom: 2px solid var(--brand-blue);
  padding-bottom: 0.35rem;
`;
const Subtitle = styled.h3`
  color: var(--brand-blue);
  font-size: 1rem;
  margin: 1rem 0 0.5rem 0;
`;
const P = styled.p`
  margin-bottom: 0.75rem;
  text-align: justify;
`;
const List = styled.ul`
  margin: 0.5rem 0;
  padding-left: 1.5rem;
`;
const Li = styled.li`
  margin-bottom: 0.35rem;
`;
const ContactBlock = styled.div`
  background: var(--bg-secondary, #f5f5f5);
  padding: 1rem 1.25rem;
  border-radius: 8px;
  border-left: 4px solid var(--brand-red);
  margin: 1rem 0;
  white-space: pre-line;
`;
const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin: 0.75rem 0;
  font-size: 0.95rem;
`;
const Th = styled.th`
  text-align: left;
  padding: 0.5rem 0.75rem;
  border-bottom: 2px solid var(--brand-blue);
  background: var(--bg-secondary, #f5f5f5);
`;
const Td = styled.td`
  padding: 0.5rem 0.75rem;
  border-bottom: 1px solid #eee;
`;

/**
 * Full Privacy Policy from locale bundles (`privacyWebsite.sections`).
 * Used on /privacy-policy and in registration modals.
 */
const PrivacyContent = () => {
  const { t } = useTranslation();
  const sections = t('privacyWebsite.sections', { returnObjects: true });

  if (!Array.isArray(sections)) {
    return null;
  }

  const ui = { P, List, Li, Subtitle, ContactBlock, Table, Th, Td };

  return (
    <>
      {sections.map((sec, i) => (
        <Section key={i}>
          {sec.title ? <SectionTitle>{sec.title}</SectionTitle> : null}
          <LegalBlocks blocks={sec.blocks} ui={ui} />
        </Section>
      ))}
    </>
  );
};

export default PrivacyContent;
